// weekDaysReducer.js

const initialState = []; 

const weekDaysReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_WEEK_DAYS':
      return action.payload;
   
    default:
      return state;
  }
};

export default weekDaysReducer;
